import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './Post.css';
import { useNavigate } from 'react-router-dom';


const PostCategories = () => {
        const navigate = useNavigate();
        const [userData, setUserData] = useState(null);
        useEffect(() => {
            const data = sessionStorage.getItem('userData');
            if (data) {
                setUserData(JSON.parse(data));
            }
        }, [])
  const [categories, setCategories] = useState([]);
  const [categoryInput, setCategoryInput] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const limit = 10;

  const fetchCategories = async () => {
    try {
      const res = await axios.get(`https://lionsnewsapi.emedha.in/superAdmin/categories?page=${page}&limit=${limit}`);
      setCategories(res.data.data);
      setTotal(res.data.total);
    } catch (error) {
      console.error('Failed to fetch categories', error);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, [page]);

  const handleAddOrEdit = async () => {
    try {
      if (editingId) {
        await axios.put(`https://lionsnewsapi.emedha.in/superAdmin/categories/${editingId}`, { name: categoryInput });
      } else {
        await axios.post('https://lionsnewsapi.emedha.in/superAdmin/categories', { name: categoryInput });
      }
      setCategoryInput('');
      setEditingId(null);
      fetchCategories();
    } catch (error) {
      console.error('Failed to add/edit category', error);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this category?')) return;
    try {
      await axios.delete(`https://lionsnewsapi.emedha.in/superAdmin/categories/${id}`);
      fetchCategories();
    } catch (error) {
      console.error('Failed to delete category', error);
    }
  };

  const handleEditClick = (category) => {
    setCategoryInput(category.name);
    setEditingId(category.id);
  };

  const totalPages = Math.ceil(total / limit);

      const handleLogout = () => {
        sessionStorage.removeItem('userId');
        sessionStorage.removeItem('userData');
        sessionStorage.removeItem('authToken');
        sessionStorage.removeItem('adminEmail');
        sessionStorage.removeItem('userDistrict');
        navigate('/');
    };


  return (

    <>
                <div className="sidebar-nav">
                <h2>Menu</h2>
                <ul>
                    <li><button className="side-button" onClick={() => window.location.href = '/superAdminDashboard'}>Posts</button></li>
                     <li>
          <button className="side-button" onClick={() => window.location.href = '/post-categories'}>Post Categories</button>
        </li>
                    <li><button className="side-button" onClick={() => window.location.href = '/superAdminDashboardGreetings'}>Greetings</button></li>
                    <li><button className="side-button" onClick={() => window.location.href = '/superAdminAdminUsers'}>Admin's</button></li>
                    <li><button className="side-button" onClick={() => window.location.href = '/superAdminUsers'}>Users's</button></li>
                    <li><button className="side-button" onClick={() => window.location.href = '/superAdminDashboardProfile'}>Profile</button></li>
                    <li><button className="side-button" onClick={() => window.location.href = '/superAdmin-multiple-districts'}>Multipule Districts</button></li>
                    <li><button className="side-button" onClick={handleLogout}>LogOut</button></li>
                </ul>
            </div>
<div className="category-container">
  <h2 className="category-title">Post Categories</h2>

  <div className="category-input-group">
    <input
      type="text"
      value={categoryInput}
      onChange={(e) => setCategoryInput(e.target.value)}
      placeholder="Enter category name"
      className="category-input"
    />
    <button className="btn primary" onClick={handleAddOrEdit}>
      {editingId ? 'Update' : 'Add'}
    </button>
  </div>

  <table className="category-table">
    <thead>
      <tr>
        <th>ID</th>
        <th>Category Name</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      {categories.map((cat) => (
        <tr key={cat.id}>
          <td>{cat.id}</td>
          <td>{cat.name}</td>
          <td>
            <button className="btn edit" onClick={() => handleEditClick(cat)}>Edit</button>
            <button className="btn delete" onClick={() => handleDelete(cat.id)}>Delete</button>
          </td>
        </tr>
      ))}
    </tbody>
  </table>

  <div className="pagination">
    <button
      className="btn"
      onClick={() => setPage((p) => Math.max(1, p - 1))}
      disabled={page === 1}
    >
      Previous
    </button>
    <span>
      Page {page} of {totalPages}
    </span>
    <button
      className="btn"
      onClick={() => setPage((p) => (p < totalPages ? p + 1 : p))}
      disabled={page === totalPages}
    >
      Next
    </button>
  </div>
</div>

    </>

  );
};

export default PostCategories;
